var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-size-reco-noo-cleed baseline"},[_c('Subtitles',{attrs:{"value-text":_vm.text}}),_c('ButtonForLoop',{attrs:{"buttons-list":_vm.buttonsList,"style-value-buttons":_vm.styleValueButtons,"class-name-buttons":_vm.classNameButtons,"class-grid":_vm.classGrid},on:{"update-input":_vm.updateInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }